/* =================================================================== */
/* Page Loader                                                          */
/* =================================================================== */

(function () {
  const loader = document.getElementById("page-loader");
  if (!loader) return;

  // ── Scroll lock ──────────────────────────────────────────────────
  let scrollY = 0;

  function lockScroll() {
    scrollY = window.scrollY;
    document.body.style.overflow = "hidden";
    document.body.style.position = "fixed";
    document.body.style.top = "-" + scrollY + "px";
    document.body.style.left = "0";
    document.body.style.right = "0";
  }

  function unlockScroll() {
    document.body.style.overflow = "";
    document.body.style.position = "";
    document.body.style.top = "";
    document.body.style.left = "";
    document.body.style.right = "";
    window.scrollTo(0, scrollY);
  }

  function preventTouch(e) {
    e.preventDefault();
  }
  loader.addEventListener("touchmove", preventTouch, { passive: false });

  lockScroll();

  // ── Hide logic ───────────────────────────────────────────────────
  let hidden = false;

  function hideLoader() {
    if (hidden) return;
    hidden = true;

    loader.removeEventListener("touchmove", preventTouch);
    unlockScroll();

    // Fade out
    loader.style.transition = "opacity 0.6s ease";
    loader.style.opacity = "0";

    // Remove after fade — with a hard fallback in case transitionend misfires
    const remove = function () {
      if (loader.parentNode) loader.parentNode.removeChild(loader);
    };

    loader.addEventListener("transitionend", remove, { once: true });
    setTimeout(remove, 800); // fallback — always fires
  }

  // Hide as soon as the page is fully loaded
  if (document.readyState === "complete") {
    hideLoader();
  } else {
    window.addEventListener("load", hideLoader, { once: true });
  }

  // Absolute hard cap — loader never stays longer than 2s no matter what
  setTimeout(hideLoader, 2000);
})();
